import { render, staticRenderFns } from "./CoachHome.vue?vue&type=template&id=072b3992"
import script from "./CoachHome.vue?vue&type=script&lang=js"
export * from "./CoachHome.vue?vue&type=script&lang=js"
import style0 from "./CoachHome.vue?vue&type=style&index=0&id=072b3992&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports